import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Box, Typography, Link, Button } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';

import { appRoutes, externalRoutes } from 'routes';
import useStyles from './useStyles';

const RightBar = props => {
  const { isSignedIn } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const links = [
    {
      path: appRoutes.quizPath(),
      label: t('components.Calculators.RightBar.assessment'),
      iconName: 'star',
      type: 'internal',
    },
    {
      path: appRoutes.quizPath(),
      label: t('components.Calculators.RightBar.monthlyBudget'),
      iconName: 'star',
      type: 'internal',
    },
    {
      path: externalRoutes.importantDecisionsPath(),
      label: t('components.Calculators.RightBar.decisions'),
      iconName: 'star',
      type: 'external',
    },
  ];

  return (
    <Box className={classes.paper}>
      <Typography variant="h2">{t('components.Calculators.RightBar.header')}</Typography>
      <Box className={classes.links}>
        {links.map(({ path, label, iconName, type }) => {
          const isInternal = type === 'internal';

          return isInternal ? (
            <Box key={label} display="flex" my={2}>
              <Icon name={iconName} />
              <Link to={path} component={RouterLink} className={classes.link}>
                <Typography variant="subtitle1">{t(label)}</Typography>
              </Link>
            </Box>
          ) : (
            <Box key={label} display="flex" my={2}>
              <Icon name={iconName} />
              <Link className={classes.link} target="_blank" href={path}>
                <Typography variant="subtitle1">{t(label)}</Typography>
              </Link>
            </Box>
          );
        })}
      </Box>
      {!isSignedIn && (
        <Link to={appRoutes.surveyPath()} component={RouterLink}>
          <Button className={classes.button}>{t('components.Calculators.RightBar.freeQuotesButton')}</Button>
        </Link>
      )}
    </Box>
  );
};

RightBar.propTypes = {
  isSignedIn: PropTypes.bool.isRequired,
};

export default RightBar;



// WEBPACK FOOTER //
// ./src/components/Calculators/components/RightBar/RightBar.js